import Vue from 'vue'
import Vuex from 'vuex'
import HTTP from './http-common';
import { eventHub } from './http-common/eventhub';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        dataItems: [],
        editoriales: [],
        estados: [],
        tipos: [],
        filtroInicial: {
            idLink: 0,
            titulo: "",
            creador: "",
            descripcion: "",
            palabraClave: "",
            url: "",
            numVisitas: 0,
            estado: "",
            idEstado: null,
            idTipo: null,
            tipo: "",
            idEditorial: null,
            editorial: "",
            fechalink: ""
        },
        tieneEditoriales: false,
        usuario: null
    },
    getters: {
        usuario: state => state.usuario,
        tiposEditorial: state => {
            let tiposSelected = state.tipos.filter(x => x.idEditorial == state.filtroInicial.idEditorial);
            tiposSelected.splice(0, 0, { id: "-1", departamento: "Todos", idEditorial: state.filtroInicial.idEditorial });
            return tiposSelected;
        }
    },
    mutations: {
        establecerEstados(state, estados) {
            state.estados = estados;
        },
        establecerTipos(state, tipos) {
            state.tipos = tipos;
        },
        establecerFiltro(state, filtro) {
            state.filtroInicial = filtro;
        },
        establecerEnlaces(state, enlaces) {
            state.dataItems = enlaces;
        },
        setEditoriales(state, editoriales) {
            state.editoriales = editoriales;
            if (editoriales.length > 0) {
                state.tieneEditoriales = true;
            }
        },
        establecerUsuario(state, usuario) {
            state.usuario = usuario;
        },
        setRefrescaEditoriales(state) {
            state.tieneEditoriales = false;
        },
        setTipoEditorial(state, valor) {
            state.filtroInicial.idTipo = valor;
        }
    },
    actions: {
        establecerEstados(context) {
            HTTP.get('Estados')
                .then(response => {
                    context.commit('establecerEstados', response.data);
                })
                .catch(e => {
                    eventHub.$emit('error', e)
                });
        },
        establecerTipos(context, idTipo) {
            context.commit('setTipoEditorial', idTipo);
            HTTP.get('Tipos', {
                params: { "idTipo": idTipo }
            })
                .then(response => {
                    context.commit('establecerTipos', response.data);
                })
                .catch(e => {
                    eventHub.$emit('error', e)
                });
        },
        establecerFiltro(context, filtro) {
            context.commit('establecerFiltro', filtro);
        },
        establecerEnlaces(context) {
            HTTP.get('Enlace', {
                params: context.state.filtroInicial
            })
                .then(response => {
                    context.commit('establecerEnlaces', response.data);
                })
                .catch(e => {
                    eventHub.$emit('error', e)
                });
        },
        async establecerEditoriales(context) {
            var result = await HTTP.get("Editoriales");
            context.commit("setEditoriales", result.data);
            return result.data;
        },
        async establecerUsuario(context) {
            if (context.getters["usuario"] == null)
            {
                var response = await HTTP.get('Usuario');
                context.commit('establecerUsuario', response.data);
            }

            return true;
        },
        async obtenerSammAccountName(context) {
            var result = await HTTP.get("UsuarioOffice");
            return result.data;
        },
        refrescaEditoriales(context) {
            context.commit("setRefrescaEditoriales");
        }
    }
})
